/// <reference types="@angular/localize" />

import * as $ from 'jquery';
(window as any)['jQuery'] = $;
(window as any)['$'] = $;

// Bootstrap 5 dropped jQuery plugins — register Tooltip and Popover as jQuery
// plugins so Summernote BS5 can call $(el).tooltip() / $(el).popover()
($ as any).fn.tooltip = function (this: any, options: any) {
  return this.each(function (this: any) {
    const bs = (window as any).bootstrap;
    if (!bs?.Tooltip) return;
    if (typeof options === 'string') {
      const instance = bs.Tooltip.getInstance(this);
      if (instance) instance[options]();
    } else {
      new bs.Tooltip(this, Object.assign({ trigger: 'hover' }, options || {}));
    }
  });
};

($ as any).fn.popover = function (this: any, options: any) {
  return this.each(function (this: any) {
    const bs = (window as any).bootstrap;
    if (!bs?.Popover) return;
    if (typeof options === 'string') {
      const instance = bs.Popover.getInstance(this);
      if (instance) instance[options]();
    } else {
      new bs.Popover(this, options || {});
    }
  });
};

import 'summernote/dist/summernote-bs5.min.js';

import { defineCustomElements } from '@truckit/shared-ui/loader';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from 'src/environments/environment';
import { StorageService } from './app/services/storage/storage.service';
import {
  buildAssistantQueryBody,
  readAssistantResponseTypeFromDom,
  resolveAssistantApiUrl,
  resolveAssistantResponseType,
} from './app/shared/assistant-endpoints';

defineCustomElements();

// ai-chat uses fetch; route all assistant calls through the Laravel API proxy.
const nativeFetch = window.fetch.bind(window);
window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
  const url =
    typeof input === 'string'
      ? input
      : input instanceof Request
        ? input.url
        : String(input);

  const laravelUrl = resolveAssistantApiUrl(url);
  if (!laravelUrl) {
    return nativeFetch(input, init);
  }

  const headers = new Headers(init?.headers);
  const token = StorageService.getCookie('AUTH');
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', token);
  }

  let body = init?.body;
  if (laravelUrl.endsWith('/query')) {
    const responseType = resolveAssistantResponseType(
      undefined,
      readAssistantResponseTypeFromDom(),
    );

    if (typeof body === 'string') {
      try {
        const parsed = JSON.parse(body);
        body = JSON.stringify(
          buildAssistantQueryBody(
            parsed.query,
            resolveAssistantResponseType(
              parsed.response_type,
              readAssistantResponseTypeFromDom(),
            ),
          ),
        );
      } catch {
        // keep original body
      }
    } else if (body instanceof FormData) {
      body = JSON.stringify(
        buildAssistantQueryBody(
          body.get('query')?.toString() ?? '',
          responseType,
        ),
      );
    }
  }

  if (!(body instanceof FormData) && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  const requestInit = { ...init, headers, body };
  if (input instanceof Request) {
    return nativeFetch(
      new Request(laravelUrl, { ...requestInit, method: input.method }),
      requestInit,
    );
  }

  return nativeFetch(laravelUrl, requestInit);
};

// Load the Google Maps JS API using the environment-specific key so local
// dev can use its own key while other builds keep the shared one.
const mapsScript = document.createElement('script');
mapsScript.src = `//maps.google.com/maps/api/js?key=${environment.googleMapAPIKey}&libraries=geometry,places&region=AU`;
mapsScript.async = true;
mapsScript.defer = true;
document.body.appendChild(mapsScript);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

defineCustomElements(window);
